module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-LightItalic-465edf1469217b323e96ca89a64fb878.woff2";